import {
  createQaProtocol,
  deleteProtocol,
  editQaProtocol,
  getAllQaProtocol,
  qaProtocolReport,
} from "../api";
import { request, success, failure, QA_PROTOCOL } from "./utilities";

export function createNewQaProtocol(data, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(QA_PROTOCOL.CREAT_QA_PROTOCOL_REQUEST));
    createQaProtocol(data).then(
      (response) => {
        if (response.data.Succeeded === true) {
          dispatch(
            success(QA_PROTOCOL.CREAT_QA_PROTOCOL_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(
            failure(
              QA_PROTOCOL.CREAT_QA_PROTOCOL_FAILURE,
              response.data.message
            )
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            QA_PROTOCOL.CREAT_QA_PROTOCOL_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function editExistQaProtocol(data, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(QA_PROTOCOL.EDIT_QA_PROTOCOL_REQUEST));
    editQaProtocol(data).then(
      (response) => {
        if (response.data.Succeeded === true) {
          dispatch(
            success(QA_PROTOCOL.EDIT_QA_PROTOCOL_SUCCESS, response.data.data)
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) {
            Notification(response.data.message, "success");
          }
        } else {
          dispatch(
            failure(QA_PROTOCOL.EDIT_QA_PROTOCOL_FAILURE, response.data.message)
          );
          if (Notification) {
            Notification(response.data.message, "error");
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            QA_PROTOCOL.EDIT_QA_PROTOCOL_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getAllQaProtocolList(data) {
  return (dispatch) => {
    dispatch(request(QA_PROTOCOL.GET_ALL_QA_PROTOCOL_REQUEST));
    getAllQaProtocol(data).then(
      (response) => {
        if (response.data.Succeeded === true) {
          dispatch(
            success(QA_PROTOCOL.GET_ALL_QA_PROTOCOL_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              QA_PROTOCOL.GET_ALL_QA_PROTOCOL_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            QA_PROTOCOL.GET_ALL_QA_PROTOCOL_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function deleteQaProtocol(id) {
  return (dispatch) => {
    dispatch(request(QA_PROTOCOL.DELETE_QA_PROTOCOL_REQUEST));
    deleteProtocol(id).then(
      (response) => {
        if (response.data.Succeeded === true) {
          //  ;
          dispatch(success(QA_PROTOCOL.DELETE_QA_PROTOCOL_SUCCESS, id));
        } else {
          dispatch(
            failure(
              QA_PROTOCOL.DELETE_QA_PROTOCOL_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            QA_PROTOCOL.DELETE_QA_PROTOCOL_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function generateQaProtocolReport(data) {
  return (dispatch) => {
    dispatch(request(QA_PROTOCOL.QA_PROTOCOL_REPORT_REQUEST));
    qaProtocolReport(data).then(
      (response) => {
        if (response.data.status === 200) {
          dispatch(
            success(QA_PROTOCOL.QA_PROTOCOL_REPORT_SUCCESS, response.data.data)
          );
        } else {
          dispatch(
            failure(
              QA_PROTOCOL.QA_PROTOCOL_REPORT_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            QA_PROTOCOL.QA_PROTOCOL_REPORT_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
